import * as types from '../../contactUs/constants/ActionTypes';
import * as consts from '../constants/ActionTypes';

const initialState = {
  experience: '',
  tab: '',
};

export default function (state = initialState, action) {
  switch (action.type) {
    case types.SWITCH_CONTENT_TOGGLE:
      return Object.assign({}, state, { experience: action.payload });
    case consts.TOGGLE_RELATED:
      return Object.assign({}, state, { tab: action.payload });
    case consts.RECEIVE_COMMUNITY_ERROR:
      return Object.assign({}, state, { tab: 'ErrorCommunity' });
    case types.RECEIVE_RELATED_ARTICLE_ERROR:
      return Object.assign({}, state, { tab: 'ErrorRelated' });
    case consts.RELATED_TOGGLE_RESET:
      return Object.assign({}, state, { tab: 'related' });
    default:
      return state;
  }
}
